/**
 * Angular Import.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';

/**
 * Service import.
 */
import { FunCollectionService } from '../common-functions/fun-collection.service';
import { GetService } from '../../dataservices/get.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FileUploadService } from '../../dataservices/file-upload.service';
import { OnboardingService } from '../../dataservices/onboarding/onboarding.service';
import { ImageGroupService } from './../../dataservices/master-service/image-group.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
/**
 * Constant Imports.
 */
import { SOCIAL_NETWORK_SITE, PRODUCT_TYPE_CONSTANT } from '../../constants/app.constants';
/**
 * Pipe import.
 */
import { FitInImgPipe } from './../../pipes/brokenimage.pipe';


/**
 * Product share component.
 */
@Component({
  selector: 'app-product-share',
  templateUrl: './product-share.component.html',
  styleUrls: ['./product-share.component.scss']
})
export class ProductShareComponent implements OnInit, OnDestroy {
  /**
   * Import input data.
   */
  @Input() data;

  /**
   * Import input data.
   */
  @Input() optionalData;

  /**
   * Share url.
   */
  public share_url = ';';

  /**
   * API response
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public api_res: any;

  /**
   * used to store Flag
   */
  public finished = false;

  /**
   * Health card status.
   */
  public healthCardFinished = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public imageEncodedUrl: any;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  public uploadfilearray = [];
  public uploadcounter = 1;
  public uploadFile_api_in_process = false;
  public uploadedFileUrl = '';
  public error_msg: string;
  public uploadedFileUrlAbsPath = '';

  /**
   * Get values from constant.
   */
  public socialNetworkSite = SOCIAL_NETWORK_SITE;

  /**
   * Share product constructor.
   */
  constructor(
    public fcs: FunCollectionService,
    private getApiService: GetService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    private fileUs: FileUploadService,
    public onboardingService: OnboardingService,
    private igs: ImageGroupService,
    private imageUrlTransform: FitInImgPipe) { }
  /**
   * On Init.
   */
  ngOnInit(): void {
    this.subscriptions.add(this.fcs.sharedImageUrl.subscribe(imageUrl => {
      this.imageEncodedUrl = imageUrl;
      if(this.optionalData) {
        this.shareExternalContent();
        return;
      } 
      this.shareContent();
    }));

  }

  /**
   * Used to handle share content.
   */
  shareContent(): void {
    if (this.imageEncodedUrl === undefined || this.imageEncodedUrl === null || this.imageEncodedUrl === '') {
      this.finished = true;
      this.subscriptions.add(this.getApiService.getShare(this.data[0].product_type, this.data[0].product_type_id).subscribe(resData => {
        this.finished = false;
        this.jwtSer.decodeData(resData).then(shareData => {
          if (shareData.status == 1) {
            this.api_res = shareData;
            this.share_url = shareData.data.share_content.share_link;
          } else if (shareData.status == 0) {
            this.fcs.errorHandeler(shareData);
          }
        });
      }));
    } else {
      this.healthCardFinished = true;
    }
  }
  /**
   * Used to handle share content.
   */
    shareExternalContent(): void {
      this.finished = false;
      this.api_res = {  data: {share_content:{...this.optionalData}}};
      this.share_url = this.optionalData.share_link;
    }

  /**
   * Used to handle fb share.
   */
  fbShare(): void {
    if (this.imageEncodedUrl === undefined || this.imageEncodedUrl === null || this.imageEncodedUrl === '') {
      const url = 'https://www.facebook.com/sharer/sharer.php?u=' + this.share_url + '&quote=' + this.api_res.data.share_content.other_content;
      window.open(url, '_blank');
    } else {
      const blob = this.fileUs.dataURItoBlob(this.imageEncodedUrl);
      if (this.uploadedFileUrlAbsPath !== '') {
        this.shareImageOnFb(this.uploadedFileUrlAbsPath);
        return;
      }
      this.uploadFileProcess(blob, this.socialNetworkSite.FACEBOOK);
    }
  }

  /**
   * Used to handle Li share
   */
  liShare(): void {
    if (this.imageEncodedUrl === undefined || this.imageEncodedUrl === null || this.imageEncodedUrl === '') {
      const url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + this.share_url + '&text=' + this.api_res.data.share_content.other_content;
      window.open(url, '_blank');
    } else {
      const blob = this.fileUs.dataURItoBlob(this.imageEncodedUrl);
      if (this.uploadedFileUrlAbsPath !== '') {
        this.shareImageOnLi(this.uploadedFileUrlAbsPath);
        return;
      }
      this.uploadFileProcess(blob, this.socialNetworkSite.LINKED_IN);
    }
  }

  /**
   * Used to handle tw share.
   */
  twShare(): void {
    if (this.imageEncodedUrl === undefined || this.imageEncodedUrl === null || this.imageEncodedUrl === '') {
      const url = 'https://twitter.com/share?url=\'\'&text=' + this.api_res.data.share_content.other_content + '&hashtags=docquityfeed,feed,docquity,docquity&via=docquity';
      window.open(url, '_blank');
    } else {
      const blob = this.fileUs.dataURItoBlob(this.imageEncodedUrl);
      if (this.uploadedFileUrlAbsPath !== '') {
        this.shareImageOnTw(this.uploadedFileUrlAbsPath);
        return;
      }
      this.uploadFileProcess(blob, this.socialNetworkSite.TWITTER);
    }
  }

  uploadFileProcess(base64, socialNetworkSite): void {
    const blob = base64;
    let BYTES_PER_CHUNK = 1000024; // **1MB chunk sizes.
    const SIZE = blob.size;
    if (SIZE > 100024) {
      BYTES_PER_CHUNK = 100024;
    } else if (SIZE > 10024) {
      BYTES_PER_CHUNK = 10024;
    } else {
      BYTES_PER_CHUNK = 1024;
    }
    let start = 0;
    let end = BYTES_PER_CHUNK;
    const d = new Date();
    const n = d.getTime();

    let count_x = Math.round(SIZE / BYTES_PER_CHUNK);
    count_x += 1;
    let x = 0;
    while (start < SIZE) {

      const chunk = blob.slice(start, end);
      this.uploadfilearray[this.uploadcounter] = chunk;
      this.uploadcounter = this.uploadcounter + 1;
      start = end;
      end = start + BYTES_PER_CHUNK;
      x++;
    }

    if (x < count_x) {
      const chunk = blob.slice(start, end);
      this.uploadfilearray[this.uploadcounter] = chunk;
      this.uploadcounter = this.uploadcounter + 1;
      start = end;
      end = start + BYTES_PER_CHUNK;
    }

    const numOfChunks = this.uploadcounter - 1; // total number of chunks
    this.uploadcounter = 1;
    const fileName = n + '.' + blob.type.split('/')[1];
    this.uploadFile_api_in_process = true;
    const file_type = blob.type;
    this.uploadFile(this.uploadfilearray[this.uploadcounter], fileName, numOfChunks, this.uploadcounter, file_type, PRODUCT_TYPE_CONSTANT.NCP_SUB_TYPE, socialNetworkSite);



  }


  /**
  * upload File
  */
  uploadFile(blobFile, filename, numOfChunks, num, file_type, product_type, socialNetworkSite): void {
    if (this.uploadfilearray.length > this.uploadcounter) {
      this.subscriptions.add(this.onboardingService.newUploadInChunk(blobFile, filename, numOfChunks, num, file_type, product_type).subscribe(data => {

        this.uploadedFileUrl = data.data.fileurl;
        this.uploadedFileUrlAbsPath = this.imageUrlTransform.transform(data.data.absolute_path, this.igs.imageGroup.fitin_1200x1200);

        this.uploadcounter = this.uploadcounter + 1;
        if (this.uploadfilearray.length > this.uploadcounter) {
          this.uploadFile(this.uploadfilearray[this.uploadcounter], filename, numOfChunks, this.uploadcounter, file_type, product_type, socialNetworkSite);
        } else {
          this.error_msg = '';
          if (this.uploadedFileUrlAbsPath != undefined) {
            if (socialNetworkSite === this.socialNetworkSite.FACEBOOK) {
              this.shareImageOnFb(this.uploadedFileUrlAbsPath);
            } else if (socialNetworkSite === this.socialNetworkSite.LINKED_IN) {
              this.shareImageOnLi(this.uploadedFileUrlAbsPath);
            } else if (socialNetworkSite === this.socialNetworkSite.TWITTER) {
              this.shareImageOnTw(this.uploadedFileUrlAbsPath);
            } else if (socialNetworkSite === this.socialNetworkSite.G_MAIL) {
              this.shareImageOnGmail(this.uploadedFileUrlAbsPath);
            }

            this.uploadFile_api_in_process = false;
          }
        }

      }, () => {
        this.uploadFile_api_in_process = false;
      }));
    }
  }

  /**
   * Handle send mail.
   */
  sendMail(): void {
    if (this.imageEncodedUrl === undefined || this.imageEncodedUrl === null || this.imageEncodedUrl === '') {
      const subject = this.api_res.data.share_content.email_title;
      const emailBody = this.api_res.data.share_content.email_content;
      // const regex = /<br\s*[\/]?>/gi;
      const email = '';
      window.location.href = 'mailto:' + email + '?subject=' + subject + '&body=' + encodeURIComponent(emailBody);
    } else {
      const blob = this.fileUs.dataURItoBlob(this.imageEncodedUrl);
      if (this.uploadedFileUrlAbsPath !== '') {
        this.shareImageOnGmail(this.uploadedFileUrlAbsPath);
        return;
      }
      this.uploadFileProcess(blob, this.socialNetworkSite.G_MAIL);
    }
  }

  shareImageOnFb(urlStr): void {
    const url = 'https://www.facebook.com/sharer/sharer.php?u=' + urlStr;
    window.open(url, '_blank');
  }

  shareImageOnTw(urlStr): void {
    const url = 'https://twitter.com/share?url=' + urlStr + '&hashtags=docquityfeed,feed,docquity,docquity&via=docquity';
    window.open(url, '_blank');
  }

  shareImageOnLi(urlStr): void {
    const url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + urlStr;
    window.open(url, '_blank');
  }

  shareImageOnGmail(urlStr): void {
    const subject = '';
    const emailBody = urlStr;
    // const regex = /<br\s*[\/]?>/gi;
    const email = '';
    window.location.href = 'mailto:' + email + '?subject=' + subject + '&body=' + encodeURIComponent(emailBody);
  }



  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.fcs.updatedSharedHealthCard('');

  }
}
